import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { Typography } from '@mui/material';
import { colorDiego, colorJazmin, colorMary, colorSusy } from '../styles';

const RadioGroupCustom = ({ tittle, options, selectedValue, onValueChange }) => {
  const getColor = (name) => {
    switch (name) {
      case 'Diego':
        return colorDiego;
      case 'Susy':
        return colorSusy;
      case 'Mary':
        return colorMary;
      case 'Jazmin MyA':
        return colorJazmin;
      default:
        break;
    }
  }

  return (
    <FormControl sx={{ paddingX: 1, paddingBottom: 1, alignItems: 'center' }}>
      <FormLabel id="demo-row-radio-buttons-group-label" >{tittle}</FormLabel>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={selectedValue}
        onChange={(e) => onValueChange && onValueChange(e.target.value)} // Callback en el cambio
        sx={{ justifyContent: 'flex-start' }}
      >
        {options && options.map(o =>
          <FormControlLabel value={o._id} control={<Radio />} sx={{ marginX: 0, padding: 0 }} label={<Typography variant='body2' sx={{ background: getColor(o.name) }}>{o.name}</Typography>} />
        )}
      </RadioGroup>
    </FormControl>
  );
}

export default RadioGroupCustom